import React from "react";

const UnderlyingDiseaseSection = ({ formData, setFormData }) => {
  return (
    <section className="form-section">
      <h3>3-2. 기저질환</h3>

      {/* 고혈압 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">고혈압</label>
          <div className="input_1col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="HTN"
                  value={value}
                  checked={formData.HTN === value}
                  onChange={(e) =>
                    setFormData({ ...formData, HTN: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 당뇨 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">당뇨</label>
          <div className="input_1col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="DM"
                  value={value}
                  checked={formData.DM === value}
                  onChange={(e) =>
                    setFormData({ ...formData, DM: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 고지혈증 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">고지혈증</label>
          <div className="input_1col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="dyslipidemia"
                  value={value}
                  checked={formData.dyslipidemia === value}
                  onChange={(e) =>
                    setFormData({ ...formData, dyslipidemia: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 간경화 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">간경화</label>
          <div className="input_1col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="LC"
                  value={value}
                  checked={formData.LC === value}
                  onChange={(e) =>
                    setFormData({ ...formData, LC: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 심부전 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">심부전</label>
          <div className="input_1col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="CHF"
                  value={value}
                  checked={formData.CHF === value}
                  onChange={(e) =>
                    setFormData({ ...formData, CHF: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 뇌졸중 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">뇌졸중</label>
          <div className="input_1col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="stroke"
                  value={value}
                  checked={formData.stroke === value}
                  onChange={(e) =>
                    setFormData({ ...formData, stroke: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* Pacemaker */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">Pacemaker</label>
          <div className="input_1col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="PM"
                  value={value}
                  checked={formData.PM === value}
                  onChange={(e) =>
                    setFormData({ ...formData, PM: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* ICD */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">ICD</label>
          <div className="input_1col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="ICD"
                  value={value}
                  checked={formData.ICD === value}
                  onChange={(e) =>
                    setFormData({ ...formData, ICD: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 신부전 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">신부전</label>
          <div className="input_1col">
            {["예(투석O)", "예(투석X)", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="CKD"
                  value={value}
                  checked={formData.CKD === value}
                  onChange={(e) =>
                    setFormData({ ...formData, CKD: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 암/혈액암 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">암/혈액암</label>
          <div className="input_1col">
            {["예(완치)", "예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="malig"
                  value={value}
                  checked={formData.malig === value}
                  onChange={(e) =>
                    setFormData({ ...formData, malig: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UnderlyingDiseaseSection;
